import createModalModel from './lib/create_modal_model';

export default createModalModel({
  modelName: 'WebhookVerification',
  properties: {},
});
